const colorCodes = {
  BasicsWhite: '#ffffff',
  Turquoise10: '#effbfb',
  Turquoise20: '#dff6f6',
  Turquoise30: '#bfeded',
  Turquoise40: '#a0e4e4',
  Turquoise50: '#80dbdb',
  Turquoise60: '#60d2d2',
  Turquoise70: '#40c9c9',
  Turquoise80: '#31afaf',
  Turquoise90: '#288f8f',
  Turquoise100: '#1f6f6f',
  Turquoise110: '#165050',
  Turquoise120: '#0d3030',
  Turquoise130: '#041010',
  Yellow10: '#fefaeb',
  Yellow20: '#fdf6d8',
  Yellow30: '#fdf1c4',
  Yellow40: '#fbe89d',
  Yellow50: '#f9de76',
  Yellow60: '#f8d54f',
  Yellow70: '#f6cc28',
  Yellow80: '#ebbd0a',
  Yellow90: '#c49d08',
  Yellow100: '#9d7e07',
  Yellow110: '#765f05',
  Yellow120: '#4e3f03',
  Yellow130: '#272002',
  Grey10: '#f2f2f2',
  Grey20: '#e5e5e5',
  Grey30: '#cccccc',
  Grey40: '#b2b2b2',
  Grey50: '#999999',
  Grey60: '#808080',
  Grey70: '#666666',
  Grey80: '#4d4d4d',
  Grey90: '#333333',
  Grey100: '#1a1a1a',
  DarkGreen: '#093532',
};

const colorSchematics = {
  base: {
    Background: {
      White: colorCodes.BasicsWhite,
      Grey2: colorCodes.Grey20,
    },
    Border: {
      Primary: colorCodes.Turquoise130,
      Secondary: colorCodes.Grey40,
      Brand: colorCodes.Turquoise90,
      White: colorCodes.BasicsWhite,
    },
    Text: {
      Primary: colorCodes.Turquoise120,
      PrimaryStatic: colorCodes.Turquoise120,
      Secondary: 'rgba(13, 48, 48, 0.70)',
      SecondaryStatic: colorCodes.Grey70,
      Brand: colorCodes.Turquoise110,
      BrandLighter: colorCodes.Turquoise10,
      Link: colorCodes.Turquoise100,
      DarkGreen: colorCodes.DarkGreen,
    },
    Icon: {
      Primary: colorCodes.Turquoise130,
      PrimaryStatic: colorCodes.Turquoise130,
      Brand: colorCodes.Turquoise110,
      BrandStatic: colorCodes.Turquoise110,
      BrandLighter: colorCodes.Turquoise10,
    },
  },
  components: {
    fixedTop: {
      Background: {
        Default: colorCodes.Turquoise20,
        Open: colorCodes.Turquoise110,
      },
      Text: {
        Default: colorCodes.Turquoise120,
        Open: colorCodes.Turquoise10,
      },
      Icon: {
        Open: colorCodes.Turquoise10,
      },
    },
    fixedBottom: {
      ActionBar: {
        Background: {
          Default: colorCodes.Turquoise30,
        },
      },
      DeclarationDrawer: {
        Background: {
          Body: colorCodes.Yellow30,
          Header: colorCodes.Yellow40,
        },
        ViewButton: {
          Background: {
            Default: colorCodes.Yellow20,
            Hover: colorCodes.Yellow30,
          },
        },
      },
      StatusBar: {
        Background: {
          Default: colorCodes.Yellow10,
        },
      },
      Drag: {
        Fill: {
          Default: colorCodes.Yellow70,
        },
      },
    },
    footer: {
      Background: {
        Default: colorCodes.Turquoise60,
      },
    },
    button: {
      Primary: {
        Background: {
          Default: colorCodes.Turquoise110,
          Hover: colorCodes.Turquoise130,
          Focus: colorCodes.Turquoise110,
          Active: colorCodes.Turquoise110,
          Disabled: colorCodes.Turquoise110,
        },
        Text: {
          Default: colorCodes.Turquoise10,
          Hover: colorCodes.Turquoise10,
          Focus: colorCodes.Turquoise10,
          Active: colorCodes.Turquoise10,
          Disabled: colorCodes.Turquoise10,
        },
      },
      Secondary: {
        Background: {
          Default: colorCodes.Turquoise90,
          Hover: colorCodes.Turquoise110,
          Focus: colorCodes.Turquoise90,
          Active: colorCodes.Turquoise90,
          Disabled: colorCodes.Turquoise90,
        },
        Text: {
          Default: colorCodes.Turquoise10,
          Hover: colorCodes.Turquoise10,
          Focus: colorCodes.Turquoise10,
          Active: colorCodes.Turquoise10,
          Disabled: colorCodes.Turquoise10,
        },
      },
      Tertiary: {
        Background: {
          Default: colorCodes.Turquoise10,
          Hover: colorCodes.Turquoise30,
          Focus: colorCodes.Turquoise10,
          Active: colorCodes.Turquoise10,
          Disabled: colorCodes.Turquoise10,
        },
        Text: {
          Default: colorCodes.Turquoise130,
          Hover: colorCodes.Turquoise130,
          Focus: colorCodes.Turquoise130,
          Active: colorCodes.Turquoise130,
          Disabled: colorCodes.Turquoise130,
        },
      },
      Quarternary: {
        Background: {
          Default: colorCodes.Yellow70,
          Hover: colorCodes.Yellow80,
          Focus: colorCodes.Yellow70,
          Active: colorCodes.Yellow70,
          Disabled: colorCodes.Yellow70,
        },
        Text: {
          Default: colorCodes.Yellow130,
          Hover: colorCodes.Yellow130,
          Focus: colorCodes.Yellow130,
          Active: colorCodes.Yellow130,
          Disabled: colorCodes.Yellow120,
        },
      },
      Ghost: {
        Text: {
          Default: colorCodes.Turquoise100,
          Hover: colorCodes.Turquoise100,
          Focus: colorCodes.Turquoise100,
          Active: colorCodes.Turquoise100,
          Disabled: colorCodes.Turquoise100,
        },
      },
      GhostStatic: {
        Text: {
          Default: colorCodes.Turquoise100,
          Hover: colorCodes.Turquoise100,
          Focus: colorCodes.Turquoise100,
          Active: colorCodes.Turquoise100,
          Disabled: colorCodes.Turquoise100,
        },
      },
    },
    statusTag: {
      Background: {
        Default: colorCodes.Yellow50,
        Hover: colorCodes.Yellow70,
      },
    },
    accordion: {
      ListItem: {
        Background: colorCodes.Turquoise10,
        Border: colorCodes.Turquoise10,
      },
      Background: {
        Default: colorCodes.Turquoise30,
      },
    },
    card: {
      Background: {
        Default: colorCodes.Turquoise10,
      },
    },
    banner: {
      Background: {
        Default: colorCodes.Turquoise110,
      },
    },
    inputField: {
      Background: {
        Default: colorCodes.BasicsWhite,
      },
    },
    caret: {
      Fill: {
        Default: colorCodes.Turquoise90,
      },
    },
    partiHero: {
      Background: {
        Default: colorCodes.Turquoise20,
      },
    },
    toggleButton: {
      Background: {
        Default: colorCodes.Turquoise110,
        Selected: colorCodes.Turquoise100,
      },
    },
    electionTypeToggle: {
      Background: {
        Default: colorCodes.Grey20,
        Selected: colorCodes.BasicsWhite,
      },
    },
    partyListItem: {
      Background: {
        Default: colorCodes.Turquoise10,
        Hover: colorCodes.Turquoise30,
      },
    },
    notificationListItem: {
      Background: {
        Default: colorCodes.Yellow10,
        Hover: colorCodes.Yellow30,
      },
      Border: {
        Default: colorCodes.Grey40,
      },
    },
    overlay: {
      Background: {
        Default: 'rgba(40, 143, 143, 0.56)',
      },
    },
    alertBanner: {
      Background: {
        Default: colorCodes.Turquoise110,
      },
      Text: {
        Default: colorCodes.Turquoise10,
      },
      Icon: {
        Default: colorCodes.Turquoise10,
      },
    },
    notificationBar: {
      Background: {
        Default: colorCodes.Turquoise10,
      },
      Text: {
        Default: colorCodes.Turquoise120,
      },
      Icon: {
        Default: colorCodes.Turquoise110,
      },
    },
    checkbox: {
      Fill: {
        Default: colorCodes.Turquoise110,
        Disabled: colorCodes.Grey50,
      },
    },
    dropdown: {
      SelectedListItem: {
        Background: {
          Default: colorCodes.Turquoise60,
        },
      },
    },
  },
};

export const colors = colorSchematics;

/*
export enum Colors {
  Primary = 'primary',
  Secondary = 'secondary',
  Black = 'black',
  VeryLightPink = 'veryLightPink',
  White = 'white',
  LightGrey = 'lightGrey',
  Grey = 'grey',
  PureWhite = 'pureWhite',
  BorderGrey = 'borderGrey',
  InfoGreen = 'infoGreen',
  DisabledGreen = 'disabledGreen',
  DisabledGreenText = 'disabledGreenText',
  BattleshipGrey = 'battleshipGrey',
  Warning = 'warning',

  ButtonBackground = '#165050',
  NewWhite = '#DCF9F7',
  LightBlue = '#BFEDED',
  DarkGreen = '#093532',
  Link = '#288F8F',
  PureBlack = '#000000',
  Turquoise = '#80DBDB',
  Text = 'text',
  SecondaryHeadline = 'secondaryHeadline',
  StatusBackground = 'statusBackground',
  TagBackground = 'tagBackground',
  YellowBackground = '#F6CC28', //'yellowBackground',


  // cleanup
  BackgroundDefault = 'backgroundDefault', 
}

const colors = {
  [Colors.Primary]: '#00b9b0',
  [Colors.Secondary]: '#1F6F6F', // This replaces instances of Battleship Grey when it's used on a white background. The contrast would be too low.
  [Colors.BattleshipGrey]: '#757676',
  [Colors.Black]: '#333333',
  [Colors.VeryLightPink]: '#eeeeee', // Background color for the page, not fully White
  [Colors.White]: '#EFFBFB',
  [Colors.PureWhite]: '#fff',
  [Colors.LightGrey]: '#e2e2e2',
  [Colors.Grey]: '#d6d6d6',
  [Colors.PureWhite]: '#ffffff',
  [Colors.BorderGrey]: '#dde2e2',
  [Colors.InfoGreen]: '#ddf4f3',
  [Colors.DisabledGreen]: '#f2fbfb',
  [Colors.DisabledGreenText]: '#657171',
  [Colors.Warning]: '#FEFAEB',
  // new colors
  [Colors.ButtonBackground]: '#165050',

  [Colors.NewWhite]: '#DCF9F7',
  [Colors.LightBlue]: '#BFEDED',
  [Colors.DarkGreen]: '#093532',
  [Colors.Link]: '#288F8F',
  [Colors.Turquoise]: '#80DBDB',
  [Colors.PureBlack]: '#000000',
  [Colors.Text]: '#0d3030',
  [Colors.SecondaryHeadline]: '#666666',
  [Colors.StatusBackground]: '#FEFAEB',
  [Colors.TagBackground]: '#F9DE76',
  [Colors.YellowBackground]: '#F6CC28',

  [Colors.BackgroundDefault]: "# "
};
*/
